import { KNOWLEDGE_LEVELS } from 'pages/Planning/types'
import { useMemo } from 'react'

const gradientStops = [
  { pct: 0, color: '#d2dffe' },
  { pct: 25, color: '#106bea' },
  { pct: 50, color: '#802afc' },
  { pct: 75, color: '#fe6e6d' },
  { pct: 100, color: '#fed236' },
]

const interpolateColor = (color1: string, color2: string, factor: number): string => {
  const c1 = color1.match(/\w\w/g)!.map((c) => parseInt(c, 16))
  const c2 = color2.match(/\w\w/g)!.map((c) => parseInt(c, 16))
  const result = c1.map((v, i) => Math.round(v + factor * (c2[i] - v)))
  return `#${result.map((v) => v.toString(16).padStart(2, '0')).join('')}`
}

const getColorForValue = (value: number, min: number, max: number): string => {
  const pct = ((value - min) / (max - min)) * 100
  for (let i = 1; i < gradientStops.length; i++) {
    const prev = gradientStops[i - 1]
    const next = gradientStops[i]
    if (pct <= next.pct) {
      const localFactor = (pct - prev.pct) / (next.pct - prev.pct)
      return interpolateColor(prev.color, next.color, localFactor)
    }
  }
  return gradientStops[gradientStops.length - 1].color
}

type KnowledgeSliderProps = {
  value: number // 0–6
  onChange: (value: number) => void
  label?: string
  disabled?: boolean
  onEnable?: () => void
}

export function KnowledgeSlider({
  value,
  onChange,
  label = 'Conhecimento',
  disabled = false,
  onEnable,
}: KnowledgeSliderProps) {
  const color = useMemo(() => getColorForValue(value, 0, KNOWLEDGE_LEVELS.length - 1), [value])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) {
      onEnable?.()
      // Aguardar um tick para a disciplina ser selecionada antes de processar
      setTimeout(() => {
        const val = Number(e.target.value)
        onChange?.(val)
      }, 0)
    } else {
      const val = Number(e.target.value)
      onChange?.(val)
    }
  }

  const handleMouseDown = (e: React.MouseEvent<HTMLInputElement>) => {
    if (disabled) {
      onEnable?.()
    }
  }

  return (
    <div className="knowledge-slider">
      <div className="slider-header">
        <span>{label}</span>
        <span className="slider-value">{value}</span>
      </div>

      <input
        type="range"
        min={0}
        max={KNOWLEDGE_LEVELS.length - 1}
        step={1}
        value={value || 0}
        onChange={handleChange}
        onMouseDown={handleMouseDown}
        className={`slider ${disabled ? 'disabled' : ''}`}
        style={{ color: '#fe6e6d' }}
        aria-label="Nível de conhecimento"
      />
    </div>
  )
}
